import { TextLayer } from "@/stellar-globe-components";
import Vue, { CreateElement } from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { EquatorialCoord } from '@hscmap/angle';

@Component
export default class extends Vue {
  @Prop({ default: 0.75 })
  alpha!: number

  render(h: CreateElement) {
    return h(TextLayer, {
      props: {
        text: this.fieldInfo,
        alpha: this.alpha,
        defaultColor: '#e8d4ac',
      },
    })
  }

  get fieldInfo() {
    const fields = {
      ja: [
        { text: "ケトゥス・ケントルム街", position: EquatorialCoord.fromDeg(35.60965596295283, -5.37993010284718).xyz },
        { text: "ボーテス街", position: EquatorialCoord.fromDeg(214.23606592840537, 51.90686493446317).xyz },
        { text: "ヘルクレス大陸", position: EquatorialCoord.fromDeg(224.4947603750461, 42.30164285744162).xyz },
        { text: "東ビルゴ大陸", position: [-0.7903260692668805, -0.6125489261184914, -0.012981423197972988] },
        { text: "ヒュドラ大陸", position: [-0.7047582686956577, 0.7093287427962116, 0.012981423197973217] },
        { text: "セクスタンス街", position: EquatorialCoord.fromDeg(150.03863119456508, 1.3474139949511539).xyz },
        { text: "ケトゥス大陸", position: EquatorialCoord.fromDeg(34.23628142074409, -0.014190998553250483).xyz },
        { text: "西ビルゴ大陸", position: [-0.9998321746731913, 0.012926915333220804, -0.012981423197972988] },
        { text: "ドラコ街", position: EquatorialCoord.fromDeg(242.69160584819917, 53.98540998543355).xyz },
        { text: "アクアリウス大陸", position: [0.9439561820094772, -0.32981541670735437, 0.012981423197973217] },
        { text: "ピスケス街", position: EquatorialCoord.fromDeg(351.7687526933402, -1.0756448840322004).xyz },
      ],
      en: [
        { text: "Cetus Centrum Town", position: EquatorialCoord.fromDeg(35.60965596295283, -5.37993010284718).xyz },
        { text: "Boötes Town", position: EquatorialCoord.fromDeg(214.23606592840537, 51.90686493446317).xyz },
        { text: "Hercules Continent", position: EquatorialCoord.fromDeg(224.4947603750461, 42.30164285744162).xyz },
        { text: "Virgo Orientem", position: [-0.7903260692668805, -0.6125489261184914, -0.012981423197972988] },
        { text: "Hydra Continent", position: [-0.7047582686956577, 0.7093287427962116, 0.012981423197973217] },
        { text: "Sextans Town", position: EquatorialCoord.fromDeg(150.03863119456508, 1.3474139949511539).xyz },
        { text: "Cetus Continent", position: EquatorialCoord.fromDeg(34.23628142074409, -0.014190998553250483).xyz },
        { text: "Virgo Occidentis", position: [-0.9998321746731913, 0.012926915333220804, -0.012981423197972988] },
        { text: "Draco Town", position: EquatorialCoord.fromDeg(242.69160584819917, 53.98540998543355).xyz },
        { text: "Aquarius Continent", position: [0.9439561820094772, -0.32981541670735437, 0.012981423197973217] },
        { text: "Pisces Town", position: EquatorialCoord.fromDeg(351.7687526933402, -1.0756448840322004).xyz },
      ],
    }
    return fields[this.$root.$i18n.locale as 'ja' | 'en']
  }

  // mounted() {
  //   this.$watch(() => this.$root.$i18n.locale, () => {
  //   })
  // }
}

// LevelDef.new(    0,  0, 'AEGIS', 'Boötes Town', 'ボーテス街', 'Boötes Town', :wide, -> (g) { (210..225) === g.ra && (50..60) === g.dec }),
// LevelDef.new(10001,  2, 'SXDS', 'Cetus Centrum Town', 'ケトゥス・ケントルム街', 'Cetus Centrum Town', :dud, -> (g) { (30..45) === g.ra && (-10..0) === g.dec }),
// LevelDef.new(10002,  2, 'DEEP2', 'Pisces Town', 'ピスケス街', 'Pisces Town', :dud, -> (g) { (345..360) === g.ra && (-10..10) === g.dec }),
// LevelDef.new(10003,  2, 'COSMOS', 'Sextans Town', 'セクスタンス街', 'Sextans Town', :dud, -> (g) { (147..152) === g.ra && (0..10) === g.dec }),
// LevelDef.new(10004,  2, 'ELAIS', 'Draco Town', 'ドラコ街', 'Draco Town', :dud, -> (g) { (230..250) === g.ra && (50..60) === g.dec }),
// LevelDef.new(10005,  4, 'XMMS', 'Cetus Continent', 'ケトゥス大陸', 'Cetus Continent', :wide, -> (g) { (26..41) === g.ra && (-10..10) === g.dec }),
// LevelDef.new(10006,  5, 'HECTOMAP', 'Hercules Continent', 'ヘルクレス大陸', 'Hercules Continent', :wide, -> (g) { (195..255) === g.ra && (40..50) === g.dec }),
// LevelDef.new(10007,  5, 'WIDE12H', 'Virgo Occidentis', '西ビルゴ大陸', 'Virgo Occidentis Continent', :wide, -> (g) { (165...195) === g.ra && (-10..10) === g.dec }),
// LevelDef.new(10008,  7, 'GAMA09H', 'Hydra Continent', 'ヒュドラ大陸', 'Hydra Continent', :wide, -> (g) { (120..165) === g.ra && (-10..10) === g.dec }),
// LevelDef.new(10009,  9, 'GAMA12H', 'Virgo Orientem', '東ビルゴ大陸', 'Virgo Orientem Continent', :wide, -> (g) { (195..230) === g.ra && (-10..10) === g.dec }),
// LevelDef.new(10010, 10, 'VVDS', 'Aquarius Continent', 'アクアリウス大陸', 'Aquarius Continent', :wide, -> (g) { ((315..360) === g.ra || (0..12) === g.ra) && (-10..10) === g.dec }),
